module.exports = __webpack_public_path__ + "img/logo.e2b98fd.svg";